module.exports = __webpack_public_path__ + "static/img/szafa_27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_27.jpg
// module id = fMyL
// module chunks = 0